var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5291 7.78956C16.6624 7.92177 16.7375 8.10099 16.7375 8.28794C16.7375 8.47469 16.6624 8.65409 16.5291 8.78633L10.641 14.6092C10.5074 14.7414 10.3262 14.8155 10.1374 14.8155C9.94841 14.8155 9.76723 14.7414 9.63373 14.6092L6.65814 11.6659C6.47968 11.4877 6.41041 11.229 6.4766 10.9867C6.54261 10.7445 6.73395 10.5554 6.97895 10.4901C7.22379 10.4248 7.4853 10.4933 7.66539 10.6701L10.1383 13.116L15.5212 7.78951C15.6546 7.65712 15.8358 7.58267 16.025 7.58267C16.214 7.58267 16.3953 7.65712 16.5288 7.78951L16.5291 7.78956ZM20.9394 4.52867L10.5 0L0.0531589 4.53101C0.0103575 6.92561 -0.0999102 13.1898 0.223096 14.4105C1.30348 18.4932 4.74131 22.0566 10.4415 25C16.544 21.8566 20.0211 18.1204 20.7788 13.892C21.0682 12.274 21.0171 8.04201 20.9396 4.52871L20.9394 4.52867Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.4e54366d3ac8e78ad03658169c13d154.svg";
export { ForwardRef as ReactComponent };